import { render, staticRenderFns } from "./NonAttendanceReasonCrudData.vue?vue&type=template&id=9db5e2e4"
import script from "./NonAttendanceReasonCrudData.vue?vue&type=script&lang=js"
export * from "./NonAttendanceReasonCrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports